import React from "react";
import Container from "../../elements/Container";
import Background from "../../../assets/img/Background/bg-footer.jpg";
import Logo from "../../../assets/svg/Logo/Logo-burger-house-white.svg";
import Facebook from "../../../assets/svg/Icones/facebook.svg";
import Instagram from "../../../assets/svg/Icones/instagram.svg";
import Twitter from "../../../assets/svg/Icones/twitter.svg";
import WhatsApp from "../../../assets/svg/Icones/whatsapp-icon.svg";
export default function Footer() {
   return (
      <Container>
         <div className="relative p-5 md:pl-10 text-white w-full font-secondary">
            <img
               src={Background}
               alt="Une planche à découper avec 2 burgers posés dessus, L'un des 2 burger est ouvert."
               className="absolute top-0 left-0 object-cover h-full w-full bg-gray-800 -z-10"
            />
            <div className="w-full h-96 flex flex-col items-center justify-center md:grid md:grid-cols-2 relative">
               {/* Left section */}
               <div className="h-full w-full pt-10 sm:pt-14">
                  <img
                     src={Logo}
                     alt="Logo Burger House de couleur blanche."
                     className="w-72 md:w-2/3 mb-5 md:mb-10 block m-auto sm:inline"
                  />
                  <p className="text-lg text-justify sm:text-start leading-6 md:leading-normal">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit.
                     Molestiae, ut odio excepturi sapiente aperiam dolorum?
                     Minus obcaecati placeat dolorem dolorum quas, libero
                     officia labore quidem aspernatur architecto sapiente odio
                     quod id distinctio sint quis optio suscipit laborum ratione
                     neque repellat. Alias, ducimus. Nulla, tenetur
                     voluptatibus! Repudiandae sed sit incidunt nostrum.
                  </p>
               </div>
               {/* Right section */}
               <div className="h-full w-full flex md:flex-col md:gap-5 items-center justify-center text-sm md:text-lg font-semibold uppercase">
                  <div className="flex gap-1 md:gap-3 items-center">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                        />
                     </svg>
                     <span>87 place Langlois | 26292 Payet</span>
                  </div>
                  <div className="flex gap-1 md:gap-3 items-center">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                        />
                     </svg>
                     <span>infos@burgerhouse.fr</span>
                  </div>
               </div>
            </div>
            <div className="w-full h-10 relative flex items-center justify-between uppercase font-semibold">
               <div className="text-xs sm:text-lg">© Burger House 2024 - Ceci est un site fictif</div>
               <div className="flex gap-2 items-center">
                  <div>
                     <a href="https://www.instagram.com/" target="_blank">
                        <img src={Instagram} alt="Logo d'Instagram" className="w-6"/>
                     </a>
                  </div>
                  <div>
                     <a href="https://www.facebook.com/" target="_blank">
                        <img src={Facebook} alt="Logo de Facebook" className="w-5"/>
                     </a>
                  </div>
                  <div>
                     <a href="https://x.com/" target="_blank">
                        <img src={Twitter} alt="Logo de Twitter" className="w-5"/>
                     </a>
                  </div>
                  <div>
                     <a href="https://www.whatsapp.com/?lang=fr_FR" target="_blank">
                        <img src={WhatsApp} alt="Logo de What's App" className="w-5"/>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </Container>
   );
}
